import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Project } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useProject = (
  projectSlug: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Project>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Project>({
    queryKey: ["projects", projectSlug],
    queryFn: async (): Promise<Project> => {
      const response = await api.get<Project>(`/projects/${projectSlug}`);
      return camelize(response.data);
    },
    ...options
  });
};
